import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {ErrorSharedComponent} from './error-shared.component';

@Component({
    selector: 'error401',
    templateUrl: './error401.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Error401Component extends ErrorSharedComponent {

  constructor(protected authService: AuthService) {
    super();
  }
}
